// Real customer reviews of these products, copied word for word from verified purchases
// on AliExpress and Amazon (including translated ones). Names are shown exactly as the
// buyers published them. Only reviews of four stars and above are included.
window.REVIEWS = [
 {
  "product": "handwarmer",
  "name": "D***n",
  "country": "United Kingdom",
  "date": "03 Jan 2026",
  "rating": 5,
  "variant": "Black",
  "text": "Seems great! Gets warm within 5 seconds, and reaches temperature in maybe 15 seconds more. Will test longevity when it's fully charged while in a walk outside (-5c here in uk currently!) 🥶 Thank you! 😄 🙏",
  "update": "Love it!! So warm and long lasting. Perfect for dog walks. 😃 🌡️",
  "images": [
   "assets/img/handwarmer-photo-usb-port.jpg",
   "assets/img/handwarmer-photo-black-wood.jpg",
   "assets/img/handwarmer-photo-black-bed.jpg",
   "assets/img/handwarmer-photo-black-held.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "P***s",
  "country": "Brazil",
  "date": "15 Feb 2026",
  "rating": 5,
  "variant": "Light Pink",
  "text": "It really warms your hand. Much better than I expected. You can choose between two temperatures, 45°C or 60°C. I also thought it would need to be recharged very quickly, but I've used it a few times and haven't had to recharge it yet.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-pink-hand.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Don",
  "country": "United States",
  "date": "10 Oct 2023",
  "rating": 5,
  "text": "these hand warmers are great. I purchased them for stocking stuffers and tested them out. I purchased another blue set from home depot that were not as powerful and turned them both on on High and timed them. these lasted for almost 8 hours on high with both sides turned on. the other ones only about 3 hours. they run at about 128 F at the start and when power starts to decrease they drop down to 105 F. they sure are warm though. cant wait for Santa to bring them for Ski season.",
  "verified": true,
  "title": "long lasting and hot!",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Verified buyer",
  "country": "Romania",
  "date": "04 Mar 2026",
  "rating": 5,
  "variant": "Black",
  "text": "Tested, heats up fast, both 60 and 45 work. The power bank function also works great. I don't know exactly the capacity yet, but i can say with a few mins of heat up testing and charging, it still is over 80% capacity on it's screen.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-unboxing.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Verified buyer",
  "country": "Spain",
  "date": "06 Feb 2026",
  "rating": 5,
  "variant": "Black",
  "text": "Instructions in Chinese and English. Easy to use. Two types of charger, so you can choose the one you want. Comes with a cord to wear on the wrist. Heat on both sides, very pleasant. Press and hold for 3 seconds to turn on and off, and the same button is pressed to increase the desired temperature. Heats instantly",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-black-usb.jpg",
   "assets/img/handwarmer-photo-black-charging.jpg",
   "assets/img/handwarmer-photo-black-box.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Realist in the OC",
  "country": "United States",
  "date": "28 Aug 2024",
  "rating": 5,
  "text": "Bought these for our ski trip. Used to use that packets that you toss but felt this is more environmentally friendly. They are a little heavy as expected but they warm up fast and doesn’t lose the heat. A full charges lasts all day on the mountains for me. Well made, love it’s reusable, good size (easy to hold), and totally worth the price.",
  "verified": true,
  "title": "Great handwarmers for skiing",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "С***К",
  "country": "Ukraine",
  "date": "12 Jan 2026",
  "rating": 5,
  "variant": "Green",
  "text": "The heater is exactly as shown in the photo and described by the seller, it heats well. I also used it as a power bank for a string of lights. It powered a string of 300 LEDs for 7.5 hours.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-green-hand.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "G***z",
  "country": "Spain",
  "date": "26 Mar 2026",
  "rating": 5,
  "variant": "Light Pink",
  "text": "It arrived quickly. the heater function is very useful, and it’s comfortable to carry everywhere. it comes with a strap along with a type c charger. i recommend it.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-cable.jpg",
   "assets/img/handwarmer-photo-pink-full.jpg",
   "assets/img/handwarmer-photo-pink-cloth.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Christopher Nguyen",
  "country": "United States",
  "date": "16 Dec 2025",
  "rating": 4,
  "text": "One of the hand warmer did not fully charged over night, only got to 98 percent not 100. I need a replacement.",
  "verified": true,
  "title": "Not fully charge.",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "R***n",
  "country": "United Kingdom",
  "date": "01 Mar 2026",
  "rating": 5,
  "variant": "Light Pink",
  "text": "Package came a bit bashed and dented, however item inside is really lovely, simple use instructions and nice heavy weighted item that sits comfortably in your hand.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-pink-lanyard.jpg",
   "assets/img/handwarmer-photo-pink-cable.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "M***s",
  "country": "Germany",
  "date": "23 Nov 2025",
  "rating": 5,
  "variant": "Black",
  "text": "The display shows the current temperature when switched on.\n Of course, it also takes a little while (<60 seconds) until 60. ° C have been reached.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-black-table.jpg",
   "assets/img/handwarmer-photo-black-display.jpg",
   "assets/img/handwarmer-photo-black-strap.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Jerry Rogers",
  "country": "United States",
  "date": "16 Dec 2024",
  "rating": 5,
  "text": "Very handy and convenient. We used them on vacation in Europe with no issues. Quick charging too.",
  "verified": true,
  "title": "Great little device!",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "J***e",
  "country": "Germany",
  "date": "17 Nov 2025",
  "rating": 4,
  "variant": "Black",
  "text": "The delivery was very fast, the material processing is okay. The function is quite simple, turn it on and choose between 2 temperature levels. Charging other devices works without issues, but only slowly. The price-performance ratio is good.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-black-40.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Verified buyer",
  "country": "Turkey",
  "date": "03 Jan 2026",
  "rating": 5,
  "variant": "Black",
  "text": "The product is good, it shuts off automatically after a certain period. You can heat it at 60 degrees 4 or 5 times; it would be better if the battery life was a bit longer. I haven't tried the power bank feature yet.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-charging.jpg",
   "assets/img/handwarmer-photo-black-hand.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Timothy G. Mack",
  "country": "United States",
  "date": "28 Dec 2025",
  "rating": 5,
  "text": "GREAT handwarmers! I got them, charged them fully, put them in a set of fleece gloves set on the lowest setting. Two and a half hours later my hands were still toasty warm and the charge level had only dropped down to 60%. Cant' beat that! You could probably easily get a full day out of each charge if you conserved the battery by only turning them on when your hands started to get cold and then off again after the warmed up.",
  "verified": true,
  "title": "Great handwarmers, great price",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "c***G",
  "country": "Spain",
  "date": "02 Dec 2025",
  "rating": 5,
  "variant": "Pink",
  "text": "Just as described, fast shipping, before the expected date. It comes discharged and needs to be charged before use, works well as a heater and as a power band.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-pink-box.jpg",
   "assets/img/handwarmer-photo-pink-hand-2.jpg",
   "assets/img/handwarmer-photo-pink-port.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Learner",
  "country": "United States",
  "date": "28 Aug 2026",
  "rating": 5,
  "text": "These new hand warmers were a pleasant surprise. The size is very nice (not too big). They can be tucked in smaller pockets, which increases usefulness.Double-sided heat is good. (NOTE: there are such things as single-sided now, too.)They warmed up quickly. I can't speak about duration yet. The LED window is a very nice feature.NOTE: Only USB-C port. (Some offer multiple ports.) This was fine for me.",
  "verified": true,
  "title": "Great double-sided option. Nice status window.",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "G***l",
  "country": "Germany",
  "date": "21 Nov 2025",
  "rating": 5,
  "variant": "Black",
  "text": "This is my first hand warmer with USB charging function. \r\n Simply find him brilliant! It is nicely sized and handy and fits in any bag and any jacket. It feels great and has several adjustment options. This way, the hand can be used for several hours and can be easily recharged when you are at home. What more could I want? In winter, I always feel very cold, especially my hands and feet, which cool down quickly. This is very unpleasant and often spoils my mood. \r\n Here we have the ideal solution for my hands. Since the item can be charged very quickly and reused countless times, it makes perfect sense to own one. \r\n Works great and I am satisfied! Absolutely recommendable.",
  "update": "",
  "images": [
   "assets/img/handwarmer-photo-black-bag.jpg",
   "assets/img/handwarmer-photo-box-2.jpg",
   "assets/img/handwarmer-photo-black-45.jpg"
  ],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "handwarmer",
  "name": "Dalyupcowgirl",
  "country": "United States",
  "date": "04 Oct 2023",
  "rating": 5,
  "text": "They take a bit to charge but come half charged. It took a bit to figure out but read the instructions and it's pretty easy. They work really quick. And get pretty warm. I plan on putting them in my pockets of my jacket to keep my hands warm. They fit in your hands well. Not too big and not to small. I'm going to Indiana this winter so taking them on a plane will be convict. There a portable size. Looking to buy more for my daughter for when she walks to and from the bus in the winter.",
  "verified": true,
  "title": "Love them",
  "images": [
   "assets/img/handwarmer-photo-buyer-01.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Chikamso Udonsi",
  "country": "United States",
  "date": "08 Jan 2026",
  "rating": 4,
  "text": "Maybe the battery life on these are reasonable but I find that I don’t more than an hour of use out of these which is usually fine but I have to recharge them a lot. They get super hot super fast which is great for my needs. I like that they magnetize together and fit really well in my hand (I have big hands). My only problem is I feel like they’re always dead or dying when I need them!",
  "verified": true,
  "title": "Useful but dies quickly",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Bryan",
  "country": "United States",
  "date": "13 Dec 2023",
  "rating": 5,
  "text": "This product works as described, my only regret is not discovering it sooner. It is perfect for cold weather sporting events, hunting season, hiking, etc. It’s the perfect size to fit in a jacket or hoodie pocket with your hands. They stay charged as well as you would expect, probably a full 2 hours each on the highest heat setting, but much longer on the lower settings which are plenty. Definitely recommend!",
  "verified": true,
  "title": "Perfect solution for cold hands",
  "images": [
   "assets/img/handwarmer-photo-buyer-03.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Dakota Kieras",
  "country": "United States",
  "date": "08 Dec 2025",
  "rating": 5,
  "text": "So far after I charged them up to 100% they came at 92% so I turned it on and it warmed up within 15 seconds level. One is quite warm level four is super warm. There are four heat levels long press to shut it off very happy with my purchase!",
  "verified": true,
  "title": "Small and compact great heat output",
  "images": [
   "assets/img/handwarmer-photo-buyer-04.jpg",
   "assets/img/handwarmer-photo-buyer-05.jpg",
   "assets/img/handwarmer-photo-buyer-06.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Ltrainer",
  "country": "United States",
  "date": "31 Dec 2025",
  "rating": 4,
  "text": "Heats up very fast. Can get very hot on level four. Build quality seems very good. I gave it four stars because I can't speak to the longevity of the product. Instructions are very clear. I ran a test on setting H2 which means both sides at heat level 2 and that will run for 6 hours. Easy to operate. I'm very pleased with this product. It also feels very nice on my neck.",
  "verified": true,
  "title": "Very nice product. Read the instructions.",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "David Shinaver",
  "country": "United States",
  "date": "03 Dec 2023",
  "rating": 5,
  "text": "These have 4 different settings and the battery life is pretty decent. I don’t really need or want the light feature but it does the job. I like how it comes in a pair, you can use one and charge the other. I think it’s a good gift idea as well.",
  "verified": true,
  "title": "Pretty decent.",
  "images": [
   "assets/img/handwarmer-photo-buyer-08.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "jessica",
  "country": "United States",
  "date": "16 Nov 2023",
  "rating": 5,
  "text": "These hand warmers are awesome. They heat up so fast and hold a charge for a very long time. It’s nice because you can charge your phone and use them as a flashlight as well. I would highly recommend these.",
  "verified": true,
  "title": "Multi use hand warmers",
  "images": [
   "assets/img/handwarmer-photo-buyer-09.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "mets9n31",
  "country": "United States",
  "date": "12 May 2026",
  "rating": 5,
  "text": "really nice units. on the higher settings it does eat the battery kinda quick. for my hand size theyre a tad big but not bad, certainly not a reason to not get. I charged them overnight and they were 100% in the morning. the splitter charging cable is a nice addition. Definitely worth the 25 bucks i paid versus going through dozens of throw away hand warmers.",
  "verified": true,
  "title": "really nice units.",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Paul Petersen",
  "country": "United States",
  "date": "12 Dec 2023",
  "rating": 5,
  "text": "Bought them for my girlfriend who is always cold. She LOVES them and always has one in hand. They are the perfect size and shape for her hands. The wrist straps are a nice soft silicone too.",
  "verified": true,
  "title": "These are amazing!!!",
  "images": [
   "assets/img/handwarmer-photo-buyer-10.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Jennifer Grace Miller",
  "country": "United States",
  "date": "17 Jan 2024",
  "rating": 4,
  "text": "I bought these for my son because he works outdoors. They work great and keep his hands warm. The only con I would have is that they are bigger than what they seem.",
  "verified": true,
  "title": "Works great",
  "images": [
   "assets/img/handwarmer-photo-buyer-12.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "P. Buchanan",
  "country": "United States",
  "date": "12 Jan 2026",
  "rating": 4,
  "text": "MUCH smaller than I expected - they are pretty darn tiny. But they seem to work well - but I'm just worried about how long the battery will last. However, since they are so small - it seems like they would be GREAT for ladies that want to keep one in their handbag that won't eat up too much space. Overall they heated up immediately when I turned them on!",
  "verified": true,
  "title": "Heats fast, but very small",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Mylina",
  "country": "United States",
  "date": "19 Feb 2024",
  "rating": 5,
  "text": "i have not had this for very long but it works great.",
  "verified": true,
  "title": "It work",
  "images": [
   "assets/img/handwarmer-photo-buyer-15.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Eileen  Szparagowski",
  "country": "United States",
  "date": "05 Dec 2025",
  "rating": 5,
  "text": "These are excellent! Easy to use and the really heat up fast. They do get hot! These go everywhere fits in my pockets great up the mountains in the snow hands are always warm battery life is good. Would recommend these if you're looking for warmers that have different heat setting take anywhere heat up fast and really do what they say. These deliver!",
  "verified": true,
  "title": "GREAT PRODUCT!!",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Mrs. D",
  "country": "United States",
  "date": "17 Dec 2025",
  "rating": 4,
  "text": "My wife bought me these for Christmas. She gave them to me early because the winter weather came on snowy and very cold. I use these while I was deer hunting and never needed to put my gloves on. I gave it 4 stars because when fully charged they would only last about three hours on level one or two. They did charge up quickly once I got home.",
  "verified": true,
  "title": "With these I didn’t need gloves",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Troy Adams",
  "country": "United States",
  "date": "08 May 2026",
  "rating": 5,
  "text": "I can't say enough good about these hand warmers. I spend a lot of time outside in the winter and these are perfect for what I don't want to wear gloves. I especially do not like to wear gloves when I'm fishing and these hand warmers are the perfect alternative. They are small, they work, and they are very affordable.",
  "verified": true,
  "title": "Toasty Warm Hands (Great Hand Warmers!)",
  "source": "amazon"
 },
 {
  "product": "handwarmer",
  "name": "Michele",
  "country": "United States",
  "date": "10 Jan 2026",
  "rating": 4,
  "text": "Bought these twice once for a gift. Battery life could be better, easy to use and the quality is good for the price. These can be set at a warm level as there are 4 adjustable levels. They are rechargeable with USB C which is easy. The design? Needs improvement imho, should be rounder. Size is good.",
  "verified": true,
  "title": "Good value winter must have",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Chavez",
  "country": "United States",
  "date": "04 Nov 2025",
  "rating": 5,
  "text": "I bought these gloves for my husband and they work excellent. They heat up quickly, especially on the fingers, and are very comfortable to wear. The battery lasts quite a while, and the material feels strong and good quality. He used them on very cold days and his hands stayed warm the whole time. You can also use your phone without taking them off, which is really convenient. Great purchase, totally recommended.",
  "verified": true,
  "title": "They heat up great and are perfect for cold weather",
  "images": [
   "assets/img/gloves-photo-buyer-01.jpg",
   "assets/img/gloves-photo-buyer-02.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Alexcar",
  "country": "United States",
  "date": "09 Sep 2026",
  "rating": 5,
  "text": "They provide enough warmth to maintain a comfortable and bearable temperature, are padded, have snaps for adjustment, a reflective strip, and are of excellent quality. They come with a storage bag to keep them clean when not in use, along with a clip to fasten the two together so they don't get lost.",
  "verified": true,
  "title": "Amazing gloves",
  "images": [
   "assets/img/gloves-photo-buyer-08.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "a***r",
  "country": "Australia",
  "date": "13 Aug 2026",
  "rating": 5,
  "variant": "",
  "text": "Good quality. good value. fast delivery. fit well.",
  "update": "",
  "images": [],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "gloves",
  "name": "Mary dominguez",
  "country": "United States",
  "date": "03 Nov 2025",
  "rating": 5,
  "text": "The temperature is perfect for really cold days; they keep my hands warm and feel light, so they don't weigh me down at all, and the battery lasts for hours. These gloves work wonderfully, they're super comfortable, and the heating works great! 👍",
  "verified": true,
  "title": "These gloves are the best.",
  "images": [
   "assets/img/gloves-photo-buyer-10.jpg",
   "assets/img/gloves-photo-buyer-11.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Bobjovi",
  "country": "United States",
  "date": "26 Oct 2025",
  "rating": 5,
  "text": "Warm and comfy. Perfect fit, I like the adjustable cuffs and wrists. Heats up fast, and the indicator lights are handy. The fingers are touch screen friendly. Gonna be great in the cold and snow.",
  "verified": true,
  "title": "Warm and comfy",
  "images": [
   "assets/img/gloves-photo-buyer-12.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Verified buyer",
  "country": "Italy",
  "date": "01 Sep 2026",
  "rating": 5,
  "variant": "",
  "text": "everything is fine",
  "update": "",
  "images": [],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "gloves",
  "name": "Leonardo más pino",
  "country": "United States",
  "date": "23 Oct 2025",
  "rating": 5,
  "text": "Very Comfortable, and quickly get warm, very good choice",
  "verified": true,
  "title": "HEATED GLOVES",
  "images": [
   "assets/img/gloves-photo-buyer-14.jpg"
  ],
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Verified buyer",
  "country": "Brazil",
  "date": "06 Aug 2026",
  "rating": 5,
  "variant": "",
  "text": "I'll test it in the cold to see if it really heats up.",
  "update": "",
  "images": [],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "gloves",
  "name": "Jose Cantos",
  "country": "United States",
  "date": "27 Aug 2026",
  "rating": 5,
  "text": "got these gloves to prepare for cold weather and outdoor jobs. they heat up quickly and stay warm for hours. the touchscreen works well, and the anti-slip grip is handy. they fit comfortably, and the waterproof feature is going to be a plus for rainy days. theyll great for work or outdoor activities. same batteries they all use for easy replacement.",
  "verified": true,
  "title": "warm and practical glikes",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Saira Salman",
  "country": "United States",
  "date": "27 Aug 2026",
  "rating": 5,
  "text": "These heated gloves work really well for keeping my hands warm in cold weather. They’re comfortable, fit nicely, and the heating is a great feature for outdoor activities. The touchscreen function is the best thing, I can use my phone easily while the gloves are on.",
  "verified": true,
  "title": "Heated Gloves",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Fatima ochoa",
  "country": "United States",
  "date": "22 Aug 2026",
  "rating": 5,
  "text": "Great heated gloves for motorcycle rides! They keep my hands warm and are very comfortable.",
  "verified": true,
  "title": "Love them",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "J. Nguyen",
  "country": "United States",
  "date": "31 Aug 2026",
  "rating": 5,
  "text": "These gloves are great for the winter time. When driving to and from work in the winter this helps with the cold steering wheel. This makes winter much more comfortable. The battery is great and I have to recharge ever few days after some good usage. The sizing was perfect for me, I got a large and normally get a large in glove sizes and it fits for me. Overall I'm very happy with my purchase and would buy this again.",
  "verified": true,
  "title": "Great gloves for some heat in the winter",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "misty irvin",
  "country": "United States",
  "date": "08 Sep 2026",
  "rating": 5,
  "text": "I have always wanted a pair of heated gloves. I saw that these were rechargeable and that was really important to me. I'm impressed with how nice they are. The sizing is accurate. They seem to be very durable and I think the last a long time. The thickness is pretty good and comfortable on my hands. They put out a nice level of heat. They don't make your hands feel like they're burning or anything like that.",
  "verified": true,
  "title": "These are really nice heated gloves and rechargeable",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Steven Thompson",
  "country": "United States",
  "date": "13 Dec 2025",
  "rating": 4,
  "text": "The gloves work exceptionally well but if you have a job like mine when you have to use your phone constantly they are too bulky for that. if you're checking emails and social media these are the ones for you. Other than not being able to use them for work they are a great buy.After leaving this review I have to file a replacement. one of the batteries started swelling during the first charge.",
  "verified": true,
  "title": "Bulky but Good",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Parminder",
  "country": "United States",
  "date": "04 Nov 2025",
  "rating": 4,
  "text": "I have used these gloves on my couple of hikes in the white mountains. Batteries lasted for 4-5hours in 25-30 degree C. It actually worked and kept my hands comfortably warm. I may order another set of batteries because if you are on 12+miles hike in mountains you may need it. I have not tested these in under 20es degree C yet.",
  "verified": true,
  "title": "Good Buy",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Razi",
  "country": "United States",
  "date": "24 Aug 2026",
  "rating": 5,
  "text": "These gloves are very high quality. I got these for my brother, who lives in Canada, as he needs gloves constantly during the winter months there. He really loved how these fit on to his hands and provide proper warmth quickly. Very easy to warm and put on for bike or regular use.",
  "verified": true,
  "title": "Heated Gloves for bike use in winter",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "TAMARA",
  "country": "United States",
  "date": "15 Dec 2025",
  "rating": 4,
  "text": "I purchased the ladies small and there's about 1/2 inch too much room at the fingertips. The rest of the glove fits well.I think they should make the fingers shorter. I have very average size lady hands.Aside from the fit, so far these are working well!",
  "verified": true,
  "title": "Unless you have long (piano) fingers, they'll fit with extra room at t",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "kaye reed",
  "country": "United States",
  "date": "09 Dec 2025",
  "rating": 4,
  "text": "Pretty good for the price. But the batteries only lasted about 3.5 hours. I would recommend getting an extra set if you pan to wear them for longer periods of time. Other than the short battery life they keep my hands warm.",
  "verified": true,
  "title": "Batteries don’t last for 8 hours.",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Jonathan Orozco",
  "country": "United States",
  "date": "30 Jan 2026",
  "rating": 4,
  "text": "They don't heat up alot. But they do get the job done and that's what matters.. the batteries done last long I bought an extra pair. But overall they are worth the buy",
  "verified": true,
  "title": "Gloves",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Brian",
  "country": "United States",
  "date": "04 Sep 2026",
  "rating": 5,
  "text": "I used these last winter, and plan to again this winter. These are great, comfortable, not too bulky, work hreat at keeping my hands warm while snowblowing.",
  "verified": true,
  "title": "Perfect, great price.",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Tara Klaker",
  "country": "United States",
  "date": "01 Sep 2026",
  "rating": 5,
  "text": "These gloves heat up quickly and keep my hands nice and warm. They’re comfortable, easy to use, and great for cold weather. Very happy with them!",
  "verified": true,
  "title": "Warm and comfortable",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Ed Bergman",
  "country": "United States",
  "date": "15 Dec 2025",
  "rating": 4,
  "text": "These gloves are very good. The only thing I wish they has was heat elements in the palm side of the glove, not just the back side.",
  "verified": true,
  "title": "Pretty good",
  "source": "amazon"
 },
 {
  "product": "gloves",
  "name": "Kaleigh",
  "country": "United States",
  "date": "27 Aug 2026",
  "rating": 5,
  "text": "Keeps my hands pretty warm even when working in -10 degrees outside",
  "verified": true,
  "title": "Good option",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "E***r",
  "country": "Switzerland",
  "date": "09 Dec 2025",
  "rating": 5,
  "variant": "",
  "text": "The package arrived in 10 days with combined shipping. The heated insoles match the description quite well. The two battery holders are for accommodating 3 AA batteries. It is also possible to connect both insoles with a long cable (which splits) to power them from a power bank. I tested the product at home and it works correctly, and I hope that even in the cold the heating holds well. I didn't need assistance from the store.",
  "update": "",
  "images": [],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "insoles",
  "name": "A***k",
  "country": "United States",
  "date": "16 Jan 2026",
  "rating": 4,
  "variant": "",
  "text": "The insoles heat up properly when connected to a power bank. The set included 2 power boxes for 1.5V batteries that are attached to the feet, but unfortunately, the hook-and-loop fasteners were too small to fit on a foot with a diameter of 33mm.",
  "update": "",
  "images": [],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "insoles",
  "name": "Verified buyer",
  "country": "Netherlands",
  "date": "09 Dec 2025",
  "rating": 5,
  "variant": "",
  "text": "Looking good",
  "update": "",
  "images": [],
  "verified": true,
  "source": "aliexpress"
 },
 {
  "product": "insoles",
  "name": "William Werba",
  "country": "United States",
  "date": "13 Feb 2026",
  "rating": 5,
  "text": "Great product and worked as advertised. In function they worked as well as the popular brands costing $300-$400 or more. It is too soon to assess their longevity. Only one BIG drawback, extra spare batteries are not available on line. I contacted the seller and have NOT heard back. I live in a very cold winter climate, suffer from diabetes and need the higher temperatures consistently. An extra pair of batteries would allow me to switch during the day. PS: A battery with double the capacity would also work.",
  "verified": true,
  "title": "Inexpensive Heated Foot Warmers",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Honey West",
  "country": "United States",
  "date": "02 Jul 2026",
  "rating": 5,
  "text": "These are great, and if anything, they are too warm! I was very happy to see that these insoles heat the entire insole, including my toes. I have used other heated insoles in the past and they were never able to heat my toes because the heating element never went that far. These keep my entire foot very warm and I am extremely satisfied with them! I highly recommend them and they also have a very long battery life.",
  "verified": true,
  "title": "Great and toasty warm!",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "FATJ",
  "country": "United States",
  "date": "08 Jan 2026",
  "rating": 5,
  "text": "Only used them once for about fours hours. Being previously frost bitten. These really did their job in single digit temperature in buffalo, ny. Normally as soon as my feet start getting cold I have to go warm up and change socks, I put these in my my shoes and strapped up the batteries. These kept my feet so warm, I was out in that weather for fours straight till job was done .",
  "verified": true,
  "title": "Best Purchase.",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Jeany",
  "country": "United States",
  "date": "30 Dec 2025",
  "rating": 4,
  "text": "Got these for my son to be able to deal with the outdoors while working. He loves them and recommends me getting a pair for hunting season. He also says the batteries are kind of heavy but worth it. He is a scrawny man so the wrap is big around his legs.",
  "verified": true,
  "title": "Son says definitely worth the money",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Kindle Customer",
  "country": "United States",
  "date": "24 May 2026",
  "rating": 5,
  "text": "Nice to have when it gets cold. Needs a bit longer wire so your boots don’t shut it off.Works like a dream anyway since wearing multiple pairs of socks on your feet wont work all that well.Feet still get cold that way, not with these.",
  "verified": true,
  "title": "Saves up on not having to double up on socks",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Peller",
  "country": "United States",
  "date": "06 Mar 2025",
  "rating": 4,
  "text": "Kept my feet fairly warm in -8° weather. I have Raynauds but love to ski. This worked much better than the disposable foot warmers. I typically use. Very glad I purchased them. Wish the battery lasted a little longer on high tho.",
  "verified": true,
  "title": "Happy Feet",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Mother of 6",
  "country": "United States",
  "date": "04 May 2026",
  "rating": 5,
  "text": "My husband is a construction worker and the code from the concrete he stands on all day was hurt his feet. These saved the day and his feet. Highly recommend. True to size recommendation.",
  "verified": true,
  "title": "Save those toes",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Ryan Sclavi",
  "country": "United States",
  "date": "24 Jan 2026",
  "rating": 5,
  "text": "Great product. Can be annoying if you're in a hurry but it's nice not worrying about proper layering to keep feet warm in sub zero (F) temperatures.",
  "verified": true,
  "title": "Warm toes in all weather.",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Teddy Dejesus",
  "country": "United States",
  "date": "25 Apr 2026",
  "rating": 5,
  "text": "Its amazing if ur outside all day. My feet where constantly sweating too hot at times. Only down side is the batteries dont last very long.",
  "verified": true,
  "title": "Winter, Great for hunting camping and hiking outdoors",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "L.D.S.D",
  "country": "United States",
  "date": "08 Apr 2025",
  "rating": 4,
  "text": "I really like these heated insoles. Kept my feet nice and toasty in freezing weather. The straps could be a little easier to put on.",
  "verified": true,
  "title": "Warm feet",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Amber R. Weinhart",
  "country": "United States",
  "date": "02 Jan 2026",
  "rating": 5,
  "text": "My husband brags it's the best gift he's ever received",
  "verified": true,
  "title": "Great",
  "source": "amazon"
 },
 {
  "product": "insoles",
  "name": "Donna Griggs",
  "country": "United States",
  "date": "02 Jan 2025",
  "rating": 4,
  "text": "My daughter loves these! Said they work great",
  "verified": true,
  "title": "Warm feet",
  "source": "amazon"
 }
];
